import { Component, OnInit } from '@angular/core';
import { ErrorAlertComponent } from '../../shared/error-alert/error-alert.component';
import { ReactiveFormsModule, FormsModule, NgForm } from '@angular/forms';
import { LoadingService } from '../../../services/general/loading.service';
import { CommonModule } from '@angular/common';
import { PhonesInterfaceRequest, crcInterfaceResponse } from '../../../interfaces/crc-consults.interface';
import { CrcConsultService } from '../../../services/crc-consult/crc-consult.service';
import { PaginatorComponent } from '../../shared/paginator/paginator.component'; // Importa el componente Paginator
import { LogTackingService } from '../../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../../interfaces/logs_tracking.interface.';


@Component({
  selector: 'app-crc-consults-phone',
  standalone: true,
  imports: [
    ErrorAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PaginatorComponent
  ],
  templateUrl: './crc-consults-phone.component.html',
  styleUrl: './crc-consults-phone.component.css'
})
export class CrcConsultsPhoneComponent implements OnInit {

  phonesRequest: PhonesInterfaceRequest = {
    phone: []
  }
  crcPhones: any = []
  phonesInput = ''
  token: string = '';
  showAlertError: boolean = false
  errorMessage = ''
  paginatedPhones: any[] = [];
  pageSize = 5;
  pageIndex = 0;
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Consultar crc',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private _loadingService: LoadingService,
    private _logsService: LogTackingService,
    private _crcConsultService: CrcConsultService
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') || '';
  }

  onSubmit(form: NgForm) {
    this.phonesInput = this.phonesInput.replace(/\s+/g, '')
    this.phonesRequest.phone = this.phonesInput.split(",")
    this._loadingService.setLoading(true)
    this._crcConsultService.consultPhones(this.token, this.phonesRequest)
      .subscribe({
        next: (response: crcInterfaceResponse) => {
          this.crcPhones = response.message
          if (this.crcPhones.length === 0) {
            this.errorMessage = 'No se encontraron resultados'
            this.log_info.details = `Error: ${this.errorMessage}`
            this.showErrorComponent(form)
          }
          for (let phone of this.crcPhones) {
            if (!phone.opcionesContacto.sms) {
              phone.opcionesContacto.sms = 'RECHAZA'
            } else {
              phone.opcionesContacto.sms = 'ACEPTA'
            }
            if (!phone.opcionesContacto.aplicacion) {
              phone.opcionesContacto.aplicacion = 'RECHAZA'
            } else {
              phone.opcionesContacto.aplicacion = 'ACEPTA'
            }
            if (!phone.opcionesContacto.llamada) {
              phone.opcionesContacto.llamada = 'RECHAZA'
            } else {
              phone.opcionesContacto.llamada = 'ACEPTA'
            }
          }
          this.log_info.details = `Success: Usuario consulto crc por telefonos`
          this.createTrackingLog()
          this.paginatePhones();
          this._loadingService.setLoading(false)
        },
        error: (error: any) => {
          this.errorMessage = error.error.message
          this.log_info.details = `Error: ${this.errorMessage}`
          this.showErrorComponent(form)
        }
      });
  }
  cancel(form: NgForm) {
    this.phonesRequest = {
      phone: []
    }
    this.crcPhones = []
    this.paginatedPhones = []
    this.pageIndex = 0
    this.pageSize = 5
    form.resetForm();
  }
  showErrorComponent(form: NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 5000);
  }

  paginatePhones() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedPhones = this.crcPhones.slice(startIndex, endIndex);
  }

  onPageChange(event: { currentPage: number; pageSize: number }) {
    this.pageIndex = event.currentPage - 1; // Ajuste para página 1
    this.pageSize = event.pageSize;
    this.paginatePhones();
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }
 
}
